import { render, staticRenderFns } from "./MessageProduct.vue?vue&type=template&id=80ba253a&scoped=true"
import script from "./MessageProduct.vue?vue&type=script&lang=js"
export * from "./MessageProduct.vue?vue&type=script&lang=js"
import style0 from "./MessageProduct.vue?vue&type=style&index=0&id=80ba253a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ba253a",
  null
  
)

export default component.exports